export default __webpack_public_path__ + "static/Chest Male-11a8c7d77b0e11034b9744b446091b9c.svg";